module.exports = __webpack_public_path__ + "img/3.b098eaa9.svg";